import React from "react";
import ReactDOM from "react-dom/client";
// Initializes the error tracker
import "~/utils/errorTracker";
import App from "./App";
import { registerCssPreloadRecovery } from "~/utils/recoverCssPreload";

// Registered before the first route import so no lazy chunk can fail ahead of it.
registerCssPreloadRecovery();

window.addEventListener("DOMContentLoaded", (_event) => {
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
});
